import type { HeaderRowConfig } from '@ztechapps/webui.data-tools'
import { CheckboxHeaderCell, MenuHeaderCell } from '@ztechapps/webui.data-tools'
import { useConversationInboxContext } from './Context'

export const ListHeader = (props: HeaderRowConfig) => {
  const { chatListWithSelection } = useConversationInboxContext()
  const { toggleSelectAll, hasSelectedAll } = chatListWithSelection

  return (
    <>
      <MenuHeaderCell />
      <CheckboxHeaderCell onChange={toggleSelectAll} checked={hasSelectedAll} />
      {props._renderDataHeaderCell()}
    </>
  )
}
